
import StationLocationView from './StationLocationView/StationLocationView'
import useSingleStation from '../../../hooks/useSingleStation'
import ErrorScreenApp from '../../../../errorHandler/components/ErrorScreenApp/ErrorScreenApp'
import { LoaderSreen } from '../../../../../common/components/molecule/Loader/Loader'

export default function StationLocationPresenter({stationId} : {stationId?: string}) {

    const {singleStationQuery:{isLoading, isError, error, data}} = useSingleStation(stationId)

    if (isError) {
        return <ErrorScreenApp axiosError={error} />
    }

    if (isLoading) {
        return <LoaderSreen heigth={"100px"} />
    }

  return (
    <StationLocationView  lat={data?.station_location_lat} lng={data?.station_location_lng} namePin={data?.station_name} zIndex={-1}/>
  )
}
